import { c as _c } from "react/compiler-runtime";
import type { AgentGraph } from '@onefootprint/request-types/dashboard';
import { useEffect, useState } from 'react';
const isAgentGraph = (value: unknown): value is AgentGraph => typeof value === 'object' && value !== null && Array.isArray((value as AgentGraph).nodes);
const getIsSafari = (): boolean => typeof window !== 'undefined' && 'safari' in window;
export const useClipboardGraph = () => {
  const $ = _c(9);
  const [clipboardGraph, setClipboardGraph] = useState(undefined);
  const [isLoaded, setIsLoaded] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getIsSafari();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isSafari = t0;
  const parseClipboardGraph = _temp;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      if (!isSafari) {
        const graph = await parseClipboardGraph();
        if (graph) {
          setClipboardGraph(graph);
        }
      }
      setIsLoaded(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const loadClipboardGraph = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      loadClipboardGraph();
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== clipboardGraph) {
    t4 = async () => {
      let graphToPaste = clipboardGraph;
      if (isSafari) {
        graphToPaste = await parseClipboardGraph();
      }
      return graphToPaste;
    };
    $[4] = clipboardGraph;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const getGraphToPaste = t4;
  const displayPasteAction = !!clipboardGraph || !isLoaded || isSafari;
  let t5;
  if ($[6] !== displayPasteAction || $[7] !== getGraphToPaste) {
    t5 = {
      getGraphToPaste,
      displayPasteAction
    };
    $[6] = displayPasteAction;
    $[7] = getGraphToPaste;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
async function _temp() {
  try {
    const parsed = JSON.parse(await navigator.clipboard.readText());
    if (isAgentGraph(parsed)) {
      return parsed;
    }
  } catch {}
}